import { render, staticRenderFns } from "./Ead.vue?vue&type=template&id=f87047d0&"
import script from "./Ead.vue?vue&type=script&lang=js&"
export * from "./Ead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports